import {cloneDeep} from "lodash";
import {ChannelListItemDataObject, ChannelListItemSenderDataObject} from '../dataObjects';
import {getArray, getString} from 'Core/helpers/data';

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {ChannelListItemDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);

	result = new ChannelListItemDataObject(
		getString(result, 'id'),
		getString(result, 'name'),
		getString(result, 'messageType'),
		getString(result, 'mobileApplicationName'),
		getArray(result, 'senderDataList').map(s => new ChannelListItemSenderDataObject(
			getString(s, 'sender', null, true),
			getString(s, 'senderName'),
		)),
		getString(result, 'providerId'),
		getArray(result, 'additionalChannelFeatures'),
	);

	return result;
}